import React from "react"
import classnames from "classnames"

import * as styles from "./divider.module.scss"

interface DividerProps {
  className?: string;
}

const Divider = ({ className }: DividerProps) => {
  return (
    <hr className={classnames(styles.root, className)} />
  )
}

export default Divider
